import React from "react";
import { IgnoreZone } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { LineCrossing } from "../EditCamera/editCameraStore/editCameraStore";
import {
  ContainedRect,
  normalizeZonePolygons,
  polygonToSvgPoints,
} from "./AlertsUtils/alertClipOverlayGeometry";

export const countActiveIgnoreZones = (ignoreZones: IgnoreZone[]): number =>
  ignoreZones.filter(
    (zone) => normalizeZonePolygons(zone.coordinates).length > 0
  ).length;

export const AlertClipOverlays = ({
  contentRect,
  ignoreZones,
  lineCrossings,
  showIgnoreZones,
  showLineCrossings,
}: {
  contentRect: ContainedRect;
  ignoreZones: IgnoreZone[];
  lineCrossings: LineCrossing[];
  showIgnoreZones: boolean;
  showLineCrossings: boolean;
}) => {
  if (!showIgnoreZones && !showLineCrossings) {
    return null;
  }
  if (!contentRect.width || !contentRect.height) {
    return null;
  }

  // The ignore_zones endpoint returns one entry per zone *type* the camera
  // supports, whether or not anything is drawn for it. Only zones with at
  // least one polygon are active, so count those (same rule the SVG uses).
  const zoneCount = showIgnoreZones ? countActiveIgnoreZones(ignoreZones) : 0;
  const crossingCount = showLineCrossings ? lineCrossings.length : 0;

  return (
    <>
      <svg
        className="pointer-events-none absolute"
        viewBox="0 0 1 1"
        preserveAspectRatio="none"
        style={{
          left: contentRect.x,
          top: contentRect.y,
          width: contentRect.width,
          height: contentRect.height,
        }}
      >
        {showIgnoreZones &&
          ignoreZones.map((zone, zoneIndex) =>
            normalizeZonePolygons(zone.coordinates).map((polygon, polygonIndex) => (
              <polygon
                key={`${zone.label || zoneIndex}-${polygonIndex}`}
                points={polygonToSvgPoints(polygon)}
                stroke={zone.line_color || "#FF8400"}
                strokeWidth="0.006"
                fill={zone.line_color || "#FF8400"}
                fillOpacity="0.28"
              />
            ))
          )}
        {showLineCrossings &&
          lineCrossings.map((line, index) => {
            const [start, end] = line.coordinates || [];
            if (!start || !end) return null;
            return (
              <line
                key={line.id ?? index}
                x1={start[0]}
                y1={start[1]}
                x2={end[0]}
                y2={end[1]}
                stroke={line.color || "#0288D1"}
                strokeWidth="0.01"
              />
            );
          })}
      </svg>
      {(zoneCount > 0 || crossingCount > 0) && (
        <div className="absolute left-2 top-2 z-10 rounded bg-black/65 px-2 py-1 font-mulish text-[11px] font-bold text-white">
          {zoneCount > 0 &&
            `${zoneCount} active ignore zone${zoneCount === 1 ? "" : "s"}`}
          {zoneCount > 0 && crossingCount > 0 && " · "}
          {crossingCount > 0 &&
            `${crossingCount} line crossing${crossingCount === 1 ? "" : "s"}`}
        </div>
      )}
    </>
  );
};
